import styled from '@emotion/styled';
import { Button, Divider, Table } from 'antd';
import { useEffect, useState } from 'react';
import { YELLOW } from '../../../shared/colors';

const Container = styled.div`
  th {
    background-color: ${YELLOW} !important;
    color: white !important;
    font-weight: bold;
  }

  .style-row {
    font-family: Poppins-L;
    color: black;

    &:hover > td {
      background-color: #bdbdbd !important;
      cursor: pointer;
    }
  }

  .even {
    background-color: #eee;
  }

  .ant-table.ant-table-small .ant-table-tbody > tr > td {
    padding: 2px 5px;
  }

  > .picker {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    width: 100%;
    margin-bottom: 10px;
  }

  .form-control-lg {
    min-height: 36px;
    min-width: 240px;
    padding: 6px 10px;
  }

  @media (max-width: 767px) {
    h2 {
      font-size: 20px;
    }

    > .picker {
      align-items: stretch;
      flex-direction: column;
    }

    .form-control-lg {
      min-width: 0;
      width: 100%;
    }
  }
`;

export const RegRegion = () => {
  const [reglements, setReglements] = useState<any[]>([]);
  const [filterReglements, setFilterReglements] = useState<any[]>([]);
  const [selectData, setSelectData] = useState('');

  useEffect(() => {
    setReglements(REGLEMENTS);
    setFilterReglements(REGLEMENTS);
  }, []);

  const filter = () => {
    if (selectData) {
      setFilterReglements(
        reglements.filter((ac) => {
          console.log(selectData, reglements, ac.titre.includes(selectData));
          if (ac.titre.includes(selectData) > -1) {
            return true;
          }
          return false;
        }),
      );
    }
  };

  const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setSelectData(value);
  };
  const COLUMNS = [
    {
      title: 'Thème',
      dataIndex: 'theme',
      width: 400,
    },
    {
      title: 'Titre du document',
      dataIndex: 'titre',
      render: (cell: any, row: any) => (
        <span onClick={() => window.open(row.link, '_blank')}>{cell}</span>
      ),
      width: 1300,
    },
    {
      title: 'Taille',
      dataIndex: 'taille',
      width: 200,
    },
    {
      title: 'Pays',
      dataIndex: 'pays',
      width: 200,
    },
    {
      title: 'Année',
      dataIndex: 'annee',
      width: 200,
    },
  ];

  return (
    <Container>
      <h2>RÈGLEMENTS PAR REGION</h2>
      <Divider style={{ backgroundColor: 'orange', marginBottom: 10 }} />
      <div className='picker'>
        <input
          className='form-control-lg'
          placeholder='Rechercher'
          type='text'
          onChange={handleInput}
        />
        <Button className='butt' onClick={filter}>
          Valider
        </Button>
      </div>

      <div></div>
      <Table
        columns={COLUMNS}
        dataSource={filterReglements}
        rowClassName={(row, index) =>
          index % 2 === 0 ? 'style-row even' : 'style-row'
        }
        scroll={{ x: 1000 }}
        size='small'
        // style={{ zoom: 1 }}
        // pagination={false}
      />
    </Container>
  );
};

const REGLEMENTS = [
  {
    theme: 'Politique des changes',
    titre:
      'Règlement N°02/CEMAC/UMAC/CM portant insaisissabilité des comptes en devises dans la CEMAC des entreprises extractives',
    taille: '1 MB',
    pays: 'CEMAC',
    annee: '2022',
    link: 'https://www.beac.int/wp-content/uploads/2022/05/Reglement-02-CEMAC-UMAC.pdf',
  },
  {
    theme: 'Politique des changes',
    titre:
      'Règlement N°01/CEMAC/UMAC/CM portant modalités de mise en oeuvre de certaines dispositions de la réglementation des changes par les entreprises extractives résidentes',
    taille: '2 MB',
    pays: 'CEMAC',
    annee: '2022',
    link: 'https://www.beac.int/wp-content/uploads/2022/05/Reglement-01-CEMAC-UMAC.pdf',
  },
  {
    theme: 'Politique des changes',
    titre:
      'Reglamento 02/CEMAC/UMAC/CM relativo a la inembargabilidad en la CEMAC de las cuentas en divisas de las empresas extractivas',
    taille: '922 KB',
    pays: 'CEMAC',
    annee: '2022',
    link: 'https://www.beac.int/wp-content/uploads/2022/03/REGLEMENT-N%C2%B002-DU-23-12-2021-ESPAGNOL.pdf',
  },
  {
    theme: 'Politique des changes',
    titre:
      'Regulation N°02/CEMAC/UMAC/CM on the unseizability of foreign currency accounts in CEMAC of extractive companies',
    taille: '866 KB',
    pays: 'CEMAC',
    annee: '2022',
    link: 'https://www.beac.int/wp-content/uploads/2022/03/REGULATION-N%C2%B002-ON-THE-UNSEIZABILITY-OF-FOREIGN-CURRENCY-ACCOUNT25032022153650.pdf',
  },
  {
    theme: 'Politique des changes',
    titre:
      'Reglamento 01/CEMAC/UMAC/CM relativo a la applicación de determinadas disposiciones de la Reglamentación cambiaria por las empresas extractivas residentes',
    taille: '2 MB',
    pays: 'CEMAC',
    annee: '2022',
    link: 'https://www.beac.int/wp-content/uploads/2022/03/REGLEMENT-N%C2%B001-DU-23-12-2021-ESPAGNOL.pdf',
  },
  {
    theme: 'Politique des changes',
    titre:
      'Regulation N°01/CEMAC/UMAC/CM on the implementation of certain provisions of the foreign exchange regulations by the resident extractive companies',
    taille: '2 MB',
    pays: 'CEMAC',
    annee: '2022',
    link: 'https://www.beac.int/wp-content/uploads/2022/03/REGULATION-N%C2%B001-ON-THE-IMPLEMENTATION-OF-CERTAIN-PROVISIONS25032022153528.pdf',
  },
  {
    theme: 'Politique des changes',
    titre:
      'Règlement N°02/18/CEMAC/UMAC/CM portant règlementation des changes dans la CEMAC',
    taille: '3 MB',
    pays: 'CEMAC',
    annee: '2020',
    link: 'https://www.beac.int/wp-content/uploads/2020/06/REGLEMENT-02-18-CEMAC-UMAC-CM_001.pdf',
  },
  {
    theme: 'Politique des changes',
    titre:
      'Regulation N°02/18/CEMAC/CAMU/CM on the regulation of foreign exchange in the CEMAC',
    taille: '8 MB',
    pays: 'CEMAC',
    annee: '2020',
    link: 'https://www.beac.int/wp-content/uploads/2020/06/REGULATION_compressed.pdf',
  },
  {
    theme: 'Politique des changes',
    titre:
      'للائحة رقم 02/CEMAC/UMAC/CM/18 بشأن تنظيم الصرف في الجماعة الاقتصادية والنقدية لوسط أفريقيا',
    taille: '6 MB',
    pays: 'CEMAC',
    annee: '2020',
    link: 'https://www.beac.int/wp-content/uploads/2020/06/REGLEMENT_arabe_compressed.pdf',
  },
  {
    theme: 'Politique des changes',
    titre:
      'Reglamento N°02/18/CEMAC/UMAC/CM sobre la reglementación de cambios en la CEMAC',
    taille: '3 MB',
    pays: 'CEMAC',
    annee: '2020',
    link: 'https://www.beac.int/wp-content/uploads/2020/08/Reglamento-Num-02_CEMAC_UMAC_ok_compressed-4.pdf',
  },
];
